import Particles from "react-tsparticles";

export default function SparklesBackground() {
  return (
    <Particles
      id="tsparticles"
      options={{
        fullScreen: { enable: true, zIndex: -1 },

        background: {
          color: "#0d1117"
        },

        particles: {
          number: { value: 100 },

                color: { value: ["#ffffff", "#FFD700", "#00ffff"] },

                opacity: {
                    value: 0.8,
                    animation: {
                    enable: true,
                    speed: 1,
                    minimumValue: 0.2
                    }
                },

                size: {
                    value: 2,
                    random: true
                },

                move: {
                    enable: true,
                    speed: 0.8
                },

          color: {
            value: "#ffffff"
          },

          shape: {
            type: "circle"
          },

          opacity: {
            value: 0.7,
            random: true
          },

          size: {
            value: 2,
            random: true
          },

          move: {
            enable: true,
            speed: 0.5,
            direction: "none",
            outModes: {
              default: "out"
            }
          }
        }
      }}
    />
  );
}